import { Link } from "react-router-dom";
import { starNews } from "@/mocks/specials";

export default function StarNewsStrip() {
  const loop = [...starNews, ...starNews];

  return (
    <div className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
      <div className="flex items-center justify-between border-b border-background-200 px-4 py-3 md:px-5">
        <div className="flex items-center gap-2">
          <span className="flex h-7 w-7 items-center justify-center rounded-md bg-accent-500 text-foreground-950">
            <i className="ri-megaphone-line text-sm" />
          </span>
          <h3 className="text-sm font-semibold text-foreground-950">明星资讯速递</h3>
        </div>
        <Link
          to="/stars"
          className="flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 cursor-pointer"
        >
          全部明星
          <i className="ri-arrow-right-s-line" />
        </Link>
      </div>
      <div className="group relative overflow-hidden py-4">
        <div className="flex w-max animate-marquee group-hover:[animation-play-state:paused]">
          {loop.map((news, i) => (
            <Link
              key={`${news.starId}-${i}`}
              to="/stars"
              className="mx-3 flex shrink-0 items-center gap-3 rounded-md px-3 py-1.5 transition-colors hover:bg-background-100 cursor-pointer"
            >
              <i className="ri-fire-line text-primary-500" />
              <span className="whitespace-nowrap text-sm font-medium text-foreground-800">
                {news.title}
              </span>
              <span className="whitespace-nowrap text-xs text-foreground-400">{news.date}</span>
              <span className="text-foreground-300">·</span>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}